import * as Gem from './';
if (window.__GEM_DEVTOOLS__HOOK__) {
    // 不支持多个 gem
    Object.assign(window.__GEM_DEVTOOLS__HOOK__, Object.assign({}, Gem));
}
export * from './lib/store';
export * from './lib/history';
export * from './lib/element';
export * from './lib/decorators';
export * from './lib/utils';
export * from './lib/version';
//# sourceMappingURL=index.js.map